import { useSyncExternalStore } from 'react';
import { subscribeTheme, getResolvedTheme, getThemePreference } from '../utils/theme';

// The theme in effect ("light" or "dark"). Components that draw with
// colours of their own, such as charts, use it to redraw on a change.
export const useTheme = () => useSyncExternalStore(subscribeTheme, getResolvedTheme);

// What the user chose: "system", "light" or "dark".
export const useThemePreference = () => useSyncExternalStore(subscribeTheme, getThemePreference);
